'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("pageStatus", function ($rootScope) {
  return {
    /**
     * permet de recharcher notamment les sections qui ont dans leur configuration invalidable:true
     */
    invalidate: function invalidate() {
      $rootScope.$emit("$PAGE_DATA_UPDATED");
    }
  };
});

/**
 * config.max : x - si plus de x tabs alors des flèches de scroll apparaissent pour atteindre les ongets à droites.
 */
ngModule.directive("tlTabsetPage", function ($route, $location, $pageRouter, routeUtils, directiveUtils) {
  var defaultConfig = {
    tabsetClass: "tl-tab-layout",
    pillsClass: "tl-layout-nav",
    tabParameter: "tab",
    tabs: []
  };
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills">' + '<div class="display-ib" ng-if="hasPrevious() || hasNext()" style="min-width: 40px"> ' + '<i class="fa fa-caret-left pill-previous fa-2x align-middle" ng-class="{\'darkBlue\':hasPrevious(), \'grey\':!hasPrevious()}" ng-click="previous()"></i>' + ' <i class="fa fa-caret-right pill-next fa-2x align-middle" ng-class="{\'darkBlue\':hasNext() , \'grey\':!hasNext()}"  ng-click="next()"></i>' + '</div>' + '       <tl-tabset-pill ng-repeat="tab in tabs | filter: { visible: true } track by tab.fragment"></tl-tabset-pill>' + '   </div>' + '   <div class="ts-tab-contents tl-layout-content">' + '       <tl-tabset-content ng-repeat="tab in tabs"></tl-tabset-content>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch = $attrs.$observe("config", function (configProp) {
        unwatch();
        $scope.$parent.$watch(configProp, function (config) {
          if (config == null) {
            return;
          }
          // TODO : check if re-init is working ( config change )
          ctrl.initialize(config);
        });
      });
    },
    controller: function controller($scope, $element, $rootScope) {
      var ctrl = this,
        config = null,
        tabs = ctrl.$tabs = $scope.tabs = [],
        section = null,
        initialRoute = $pageRouter.getCurrentRoute(),
        // index du premier tab visible
        firstTabIdx = 0;
      ctrl.initialize = function (_config) {
        config = _.extend(angular.copy(defaultConfig), _config);
        _.each(config.tabs, ctrl.addTab, ctrl);
        $element.addClass(config.tabsetClass);
        $element.find(".ts-tab-pills").addClass(config.pillsClass);
        var sectionParam = config.tabParameter || "tab",
          initialTabFragment = initialRoute.params[sectionParam],
          path = initialRoute.$$route.originalPath,
          routeSectionRegexp = new RegExp("^.*[\/]:" + sectionParam + "[?]?"),
          sectionParams = _.omit(initialRoute.params, sectionParam);
        var regExpExecArray = routeSectionRegexp.exec(path);
        if (regExpExecArray == null) {
          console.error("impossible de créer la regExp avec le path [" + path + ") via l'expression " + routeSectionRegexp);
        }
        section = regExpExecArray[0];
        section = routeUtils.replaceParams(section, sectionParams);
        var unregisterLocationHandler = $pageRouter.registerLocationHandler(section, function (newParams) {
          var tabId = newParams[sectionParam];
          ctrl.selectTabById(tabId);
        });
        $scope.$on("$destroy", unregisterLocationHandler);
        var initialTab = initialTabFragment && _.find(ctrl.$tabs, {
          fragment: initialTabFragment
        }) || ctrl.$tabs[0];
        ctrl.selectTab(initialTab, true);

        // reaffiche le tab si iil n'est pas visible par défaut
        if (config.max && (initialTab.index < firstTabIdx || initialTab.index >= firstTabIdx + config.max)) {
          $scope.firstTab = initialTab.index - (config.max - 1);
          if (firstTabIdx < 0) {
            firstTabIdx = 0;
          }
        }
        ctrl.updateVisibility();
      };
      ctrl.getConfig = function () {
        return config;
      };
      ctrl.getParentParameters = function () {
        var parameters = {};
        var parentTabset = directiveUtils.getParentController($element, "tlTabsetPage");
        var parentTab = directiveUtils.getParentController($element, "tlTabsetContent");
        if (parentTabset && parentTab) {
          var paramName = parentTabset.getConfig().tabParameter;
          var paramValue = parentTab.getFragment();
          parameters[paramName] = paramValue;
          _.extend(parameters, parentTabset.getParentParameters());
        }
        return parameters;
      };
      ctrl.selectTabById = function (tabId) {
        var selected = _.find(tabs, {
          fragment: tabId
        });
        if (selected) {
          ctrl.selectTab(selected);
        }
      };
      ctrl.changeUrl = function (tab) {
        // replaces :params with actual values.
        var params = ctrl.getParentParameters();
        params[config.tabParameter] = tab.fragment;
        var tabUrl = routeUtils.replaceParams(section, params);
        $location.search({}).path(tabUrl);
      };
      ctrl.selectTab = function selectTab(tab, noUrlChange) {
        _.each(tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
        if (tab.id) {
          // permet à du code d'être alerté facilement du changement de tab
          $rootScope.$emit('TlTab:' + tab.id);
        }
        if (!noUrlChange) {
          ctrl.changeUrl(tab);
        }
      };
      ctrl.addTab = function addTab(tab) {
        tab.active = false;
        tab.index = tabs.length;
        tabs.push(tab);
      };
      ctrl.updateVisibility = function () {
        for (var i = 0; i < tabs.length; i++) {
          if (i < firstTabIdx) {
            // si le tab est actif alors on le desactive
            if (tabs[i].active) {
              if (i - 1 >= firstTabIdx) {
                ctrl.changeUrl(tabs[i - 1]);
              } else {
                ctrl.changeUrl(tabs[i + 1]);
              }
            }
            tabs[i].visible = false;
          } else {
            tabs[i].visible = true;
          }
        }
      };
      $scope.hasNext = function () {
        var nextTab = firstTabIdx + (config ? config.max : 100);
        return nextTab < tabs.length;
      };
      $scope.next = function () {
        if ($scope.hasNext()) {
          firstTabIdx++;
          ctrl.updateVisibility();
        }
      };
      $scope.hasPrevious = function () {
        return firstTabIdx > 0;
      };
      $scope.previous = function () {
        if ($scope.hasPrevious()) {
          firstTabIdx--;
          ctrl.updateVisibility();
        }
      };
    }
  };
});
ngModule.directive("tlTabsetPill", function ($mdButtonInkRipple, iconUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabsetPage",
    template: '' + '<div class="ts-tab-pill tl-panel-menu" ng-click="onPillClick()" ng-class="{selected : tab.active, \'panel-opened\' : tab.panelOpened}">' + '   <i ng-show="tab.icon" class="ts-tab-pill-icon {{fullIcon}} {{tab.class}}"></i>' + '   <h1>{{ tab.title || (tab.label | translate) }}</h1>' + '</div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      $mdButtonInkRipple.attach($scope, $el);
      $scope.tab = $scope.$eval("tab");
      $el.attr("tabset-fragment", $scope.tab.fragment);
      $scope.$watch('tab.icon', function (icon) {
        $scope.fullIcon = iconUtils.getFullName(icon);
      });
      $scope.onPillClick = function () {
        tabsetCtrl.changeUrl($scope.tab);
      };
    }
  };
});
ngModule.directive("tlTabsetContent", function ($rootScope, $compile, $q, templateUtils, $controller, deferredUtils) {
  var INVALIDATION_EVENT = "$PAGE_DATA_UPDATED";
  var defaultTabConfig = {
    tabClass: "",
    unload: false,
    invalidable: false
  };
  return {
    restrict: "E",
    replace: true,
    require: ["tlTabsetContent", "^tlTabsetPage", "hideableContainer"],
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    controller: function controller($scope, $element) {
      var ctrl = this,
        tabsetCtrl = null,
        visibilityCtrl = null,
        tab = $scope.tab,
        //$scope.$eval("tab"),
        tabLoaded = false,
        tabContent = null,
        tabScope = null,
        config = null;
      var generateConfig = function generateConfig() {
        var keys = _.keys(defaultTabConfig),
          tabsetConfig = tabsetCtrl.getConfig();
        config = {};
        _.each(keys, function (key) {
          if (_.has(tab, key)) {
            config[key] = tab[key];
          } else if (_.has(tabsetConfig, key)) {
            config[key] = tabsetConfig[key];
          } else {
            config[key] = defaultTabConfig[key];
          }
        });
      };
      ctrl.$initialize = function (_tabsetCtrl, _visibilityCtrl) {
        tabsetCtrl = _tabsetCtrl;
        visibilityCtrl = _visibilityCtrl;
        generateConfig();
        $element.attr("tabset-fragment", tab.fragment);
        if (config.tabClass) {
          $element.addClass(config.tabClass);
        }
        $scope.$watch("tab.active", function (activeTab) {
          visibilityCtrl.setVisible(activeTab);
        });
        var visibilityChangeHandler = function visibilityChangeHandler(visible) {
          visible ? ctrl.showTab() : ctrl.hideTab();
        };
        visibilityCtrl.on("visibility:change", visibilityChangeHandler);
        visibilityCtrl.setVisible(tab.active || false);
        if (tab.active) {
          ctrl.showTab();
        }
        if (config.invalidable) {
          bindInvalidationEvents();
        }
      };
      var bindInvalidationEvents = function bindInvalidationEvents() {
        var invalidationHandler = function invalidationHandler() {
          if (visibilityCtrl.isVisible()) {
            return;
          }
          ctrl.unloadTabContent();
        };
        var removeInvalidationListener = $rootScope.$on(INVALIDATION_EVENT, invalidationHandler);
        $scope.$on("$destroy", function () {
          removeInvalidationListener();
        });
      };
      ctrl.getFragment = function () {
        return tab.fragment;
      };
      ctrl.usePanelLayout = function (panelLayout) {
        panelLayout ? $element.addClass("has-panel") : $element.removeClass("has-panel");
        ctrl.setPanelOpened(false);
      };

      // only used with panel layout (for pill styles purposes)
      ctrl.setPanelOpened = function (panelOpened) {
        tab.panelOpened = panelOpened;
      };
      ctrl.showTab = function () {
        if (!tabLoaded) {
          ctrl.loadTabContent();
        }
        $element.show();
      };
      ctrl.hideTab = function () {
        if (tabLoaded && (config.unload && tab.unload !== false || tab.unload)) {
          ctrl.unloadTabContent();
        }
        $element.hide();
      };
      ctrl.unloadTabContent = function () {
        if (tabScope != null) {
          tabScope.$destroy();
          tabScope = null;
          tabContent.remove();
          tabContent = null;
        }
        tabLoaded = false;
      };
      ctrl.loadTabContent = function () {
        var resolvesPromise = deferredUtils.resolvePromiseMap(tab.resolve || {});
        var templatePromise = templateUtils.loadTemplate(tab);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          tabScope = $scope.$new();
          var locals = resolves[0],
            template = resolves[1];
          if (tab.controller) {
            locals.$scope = tabScope;
            locals.$element = $element;
            $controller(tab.controller, locals);
          }
          $compile(template)(tabScope, function (content) {
            tabContent = content;
            $element.append(content);
          });
          tabLoaded = true;
        });
      };
    },
    link: function link($scope, $el, $attrs, controllers) {
      var tabController = controllers[0],
        tabsetController = controllers[1],
        visibilityCtrl = controllers[2];
      tabController.$initialize(tabsetController, visibilityCtrl);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/tabsetPage.js
// module id = 3005
// module chunks = 13